import React from 'react';
import { useSelector } from 'react-redux';

import {
  RESCHEDULE_REASON_MODAL_STAGES,
  rescheduleModalStageSelector,
} from 'features/classCreation';
import RescheduleModalConfirmStage from '../RescheduleModalConfirmStage';
import RescheduleModalReasonStage from '../RescheduleModalReasonStage';
import RescheduleModalValidationStage from '../RescheduleModalValidationStage';

function RescheduleModalStageRenderer() {
  const modalStage = useSelector(rescheduleModalStageSelector);

  switch (modalStage) {
    case RESCHEDULE_REASON_MODAL_STAGES.reason:
      return <RescheduleModalReasonStage />;
    case RESCHEDULE_REASON_MODAL_STAGES.confirm:
      return <RescheduleModalConfirmStage />;
    case RESCHEDULE_REASON_MODAL_STAGES.validation:
      return <RescheduleModalValidationStage />;
    default:
      return null;
  }
}

export default RescheduleModalStageRenderer;
